/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button, Tooltip, Modal, Spin, Skeleton, Empty } from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import ViewAsSelector from '../../components/common/ViewAsSelector';
import * as AntDIcons from '@ant-design/icons';
import axios from 'axios';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import '../common/BraineeModule.css';
import Create from './Components/Create';
import { getCourses } from '../../services/MicrocredentialsCourseTopicService';
import { getMicrocredentialCourseId, getMicrocredentialCourseName, isMicrocredentialHomework } from './microcredentialUtils';

export function HomeworkSubjects(props) {
   const navigate = useNavigate();
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);
   const user_full_name = localStorage.getItem('selected-teacher-name') ?? Utils.getCurrentUserInfo(Enums.UserInfo.fullname);
   const isMicrocredentials = props.isMicrocredentials || isMicrocredentialHomework(props.type);
   const workType = isMicrocredentials ? 'microcredential' : 'homework';
   const rootLabel = isMicrocredentials ? 'Brainee Microcredentials' : 'Brainee LMS';
   const pageTitle = isMicrocredentials ? 'Homeworks & Projects' : 'Homework & Project';
   const heroKicker = isMicrocredentials ? 'Brainee Microcredentials' : 'Brainee LMS';
   const browseTitle = isMicrocredentials ? 'Course Groups' : 'Subject Groups';
   const createTitle = isMicrocredentials ? 'Create Homeworks & Projects' : 'Create Homework';
   const createButtonLabel = isMicrocredentials ? 'Create Homeworks & Projects' : 'Create Homework & Project';
   const createActionTitle = isMicrocredentials ? 'Create new Homeworks & Projects' : 'Create new Homework & Project';
   const emptyDescription = isMicrocredentials ? 'No microcredential courses found.' : 'No records found.';
   const itemSubtitle = isMicrocredentials ? 'Open homeworks & projects list' : 'Open homework list';
   const listRoute = isMicrocredentials ? '/microcredentials/homeworks/list' : '/homeworks';

   const [userList, setUserList] = useState([]);
   const [creating, setCreating] = useState(false);
   const [subjectList, setSubjectList] = useState([]);
   const [loading, setLoading] = useState(false);
   const [createModalVisible, setCreateModalVisible] = useState(false);
   const [user_id, setUserId] = useState(localStorage.getItem('selected-teacher') ?? Utils.getCurrentUserInfo(Enums.UserInfo.id));

   useEffect(() => {
      Utils.verifyJwt();

      const allowedRoles = ['super admin', 'admin', 'teacher', 'co-teacher'];
      if (!allowedRoles.includes(user_role.toLowerCase())) {
         navigate('/home');
         return;
      }

      if (['super admin', 'admin'].includes(user_role.toLowerCase())) {
         axios.get(`${process.env.REACT_APP_API_LESSON}/listAllStaff`).then((response) => {
            if (response.data) {
               let data = response.data;
               var users = data.filter((d) => d.id !== Number(user_id)).sort((a, b) => {
                  var aVal = a['first_Name'];
                  var bVal = b['first_Name'];
                  switch (typeof aVal) {
                     case 'string':
                        return aVal.localeCompare(bVal);
                     case 'number':
                        return aVal - bVal;
                     default:
                        throw new Error('Unsupported value to sort by');
                  }
               });
               var final = data.filter((d) => d.id === Number(user_id));
               Array.prototype.push.apply(final, users);
               setUserList(final);
            }
         }, (error) => {
            console.log(error.message);
         });
      }

      getSubjects(user_id);
   }, [isMicrocredentials, navigate, user_id, user_role, workType]);

   const getSubjects = async (userid) => {
      setLoading(true);

      try {
         if (isMicrocredentials) {
            const data = await getCourses();
            const courses = (Array.isArray(data) ? data : []).map((course) => ({
               value: getMicrocredentialCourseId(course),
               name: getMicrocredentialCourseName(course),
            })).filter((course) => course.value !== null && course.name);

            setSubjectList(courses);
         } else {
            const response = await axios.get(`${process.env.REACT_APP_API_HOMEWORK}/subjectgroup?id=${userid}&t=${workType}`);
            if (response.data) {
               const subjects = response.data.map((item) => ({ value: item.value, name: item.name }));
               setSubjectList(subjects);
            }
         }
      } catch (error) {
         console.log(error.message);
         setSubjectList([]);
      } finally {
         setLoading(false);
      }
   };

   const handleCancelCreate = () => {
      setCreateModalVisible(false);
   };

   const handleOnFinishCreate = (homeworkData, fileForUpload) => {
      setCreating(true);

      if (fileForUpload.length > 0) {
         var formData = new FormData();

         fileForUpload.forEach(file => {
            formData.append('files', file);
         });

         var url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMultiple?s3path=${process.env.REACT_APP_S3_HOMEWORKS_TEACHERS_PATH}`;
         axios.post(url, formData).then(response => {
            if (response.data) {
               homeworkData.document = response.data;

               axios.post(`${process.env.REACT_APP_API_HOMEWORK}/add`, homeworkData).then(() => {
                  setCreating(false);
                  Modal.success({
                     title: pageTitle,
                     content: `${pageTitle} created.`,
                     centered: true,
                     onOk: () => { setCreateModalVisible(false); },
                  });

                  getSubjects(user_id);
               }, (error) => {
                  setCreating(false);
                  Modal.error({
                     title: pageTitle,
                     content: error.response?.data || error.message,
                     centered: true,
                     // onOk: () => { setCreateModalVisible(false); },
                  });
               });
            }
         }, () => {
            setCreating(false);
         });
      } else {
         axios.post(`${process.env.REACT_APP_API_HOMEWORK}/add`, homeworkData).then(() => {
            setCreating(false);
            Modal.success({
               title: pageTitle,
               content: `${pageTitle} created.`,
               centered: true,
               onOk: () => { setCreateModalVisible(false); },
            });

            getSubjects(user_id);
         }, (error) => {
            setCreating(false);
            Modal.error({
               title: pageTitle,
               content: error.response?.data || error.message,
               centered: true,
               // onOk: () => { setCreateModalVisible(false); },
            });
         });
      }
   };

   const itemSubjectClick = (subject, subjectname) => {
      navigate(`${listRoute}?id=${subject}&name=${encodeURIComponent(subjectname)}&staff=${user_id}`);
   };

   const handleUserChange = (id) => {
      const teacher = userList.find((item) => item.id === id);
      if (teacher) {
         localStorage.setItem('selected-teacher-name', `${teacher.first_Name.trim()} ${teacher.last_Name.trim()}`);
      }
      localStorage.setItem('selected-teacher', id);
      setUserId(id);
      getSubjects(id);
   };

   const renderSubjectSkeletons = () => (
      <div className="brainee-module-skeleton-grid">
         {Array.from({ length: 6 }).map((_, index) => (
            <div className="brainee-module-card is-skeleton" key={`homework-subject-skeleton-${index}`}>
               <Skeleton.Avatar active shape="square" className="brainee-module-card-skeleton-icon" />
               <div className="brainee-module-card-copy">
                  <Skeleton.Input active size="small" className="brainee-module-card-skeleton-title" />
                  <Skeleton.Input active size="small" className="brainee-module-card-skeleton-subtitle" />
               </div>
               <Skeleton.Button active size="small" shape="circle" className="brainee-module-card-skeleton-action" />
            </div>
         ))}
      </div>
   );

   return (
      <>
         <div className="dashboard-area-all brainee-module-page">
            <div className="dashboard-item brainee-module-shell">
               <div className="brainee-module-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'lms', node: rootLabel },
                        { key: 'hw', node: pageTitle },
                     ]}
                  />
               </div>

               <section className="brainee-module-hero">
                  <div>
                     <span className="brainee-module-kicker">{heroKicker}</span>
                     <h1>{pageTitle}</h1>
                     <p>{isMicrocredentials ? 'Choose a course to manage microcredential homeworks & projects and keep activities organized by topic.' : 'Choose a subject to manage homework & project activities, review submissions, and keep class work organized.'}</p>
                     <div className="brainee-module-meta">
                        <span><AntDIcons.BookOutlined /> {loading ? `Loading ${browseTitle.toLowerCase()}` : `${subjectList.length} ${browseTitle.toLowerCase()}`}</span>
                        <span><AntDIcons.FileTextOutlined /> {pageTitle} workspace</span>
                     </div>
                  </div>
                  <div className="brainee-module-actions">
                     {['Super Admin', 'Admin'].includes(user_role) &&
                        <ViewAsSelector
                           users={userList}
                           defaultValue={user_full_name}
                           onChange={handleUserChange}
                        />
                     }
                     <Tooltip placement="bottom" title={createActionTitle}>
                        <Button className='brainee-module-create-btn' type='primary' size='large' shape='round' onClick={() => setCreateModalVisible(true)}>
                           <AntDIcons.PlusOutlined />{createButtonLabel}
                        </Button>
                     </Tooltip>
                  </div>
               </section>

               <section className="brainee-module-panel">
                  <div className="brainee-module-panel-header">
                     <div>
                        <span className="brainee-module-kicker">Browse</span>
                        <h2>{browseTitle}</h2>
                     </div>
                     <span className="brainee-module-count">{loading ? '...' : subjectList.length}</span>
                  </div>

                  {loading
                     ? renderSubjectSkeletons()
                     : subjectList.length > 0
                        ? <div className="brainee-module-grid">
                           {subjectList.map((subject) => (
                              <button className="brainee-module-card" key={subject.value} type="button" onClick={() => itemSubjectClick(subject.value, subject.name)}>
                                 <span className="brainee-module-card-icon"><AntDIcons.BookOutlined /></span>
                                 <span className="brainee-module-card-copy">
                                    <span className="brainee-module-card-title">{subject.name}</span>
                                    <span className="brainee-module-card-subtitle">{itemSubtitle}</span>
                                 </span>
                                 <AntDIcons.RightOutlined className="brainee-module-card-arrow" />
                              </button>
                           ))}
                        </div>
                        : <div className='brainee-module-state'>
                           <Empty image="../images/brainee_mascot.png" description={emptyDescription} />
                        </div>
                  }
               </section>
            </div>
         </div>

         <Modal
            title={createTitle}
            centered
            destroyOnClose={true}
            onCancel={handleCancelCreate}
            open={createModalVisible}
            width={1040}
            footer={[
               <Button key="cancel" onClick={handleCancelCreate} disabled={creating}>Cancel</Button>,
               <Button key="save" type="primary" htmlType="submit" form="homework-subject-create-form" loading={creating}>Save</Button>,
            ]}
         >
            <Spin spinning={creating} tip={`Creating ${pageTitle.toLowerCase()}, please wait...`}>
               <Create
                  formId="homework-subject-create-form"
                  onCancelCallback={handleCancelCreate}
                  onFinishCallback={handleOnFinishCreate}
                  type={workType}
               />
            </Spin>
         </Modal>
      </>
   );
}
